export const RIO_LOGOUT_PATH = "/rio/logout";

export const redirectToLogout = (): void => {
  if (typeof window === "undefined") return;

  const path = window.location.pathname;
  if (path.includes("/logout") || path.includes("/sign-out")) return;

  window.location.href = RIO_LOGOUT_PATH;
};

export const redirectOnUnauthorized = (status: number): boolean => {
  if (status === 401) {
    redirectToLogout();
    return true;
  }
  return false;
};
